import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import io from 'socket.io-client';
import ViewSubCategories from './SubCategories';
import Cookies from 'js-cookie';
import { viewAllRecordCategory } from '../../services/categoriesServives';
import {
  updateRecord,
  viewEachRecord,
} from '../../services/subCategoriesServives';

function SubCategories(props) {
  const [name, setName] = useState('');
  const [catName, setCatName] = useState('');
  const [nameError, setNameError] = useState('');
  const [categories, setCategories] = useState([]);
  const baseURL = process.env.REACT_APP_BASE_URL_DOCUMENT;

  useEffect(() => {
    async function getEach() {
      const id = props.match.params.id;
      viewEachRecord(id)
        .then((response) => {
          setName(response.data.name);
          setCatName(response.data.category);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    async function clientSocket() {
      const socket = io(baseURL);

      // Socket for update sub document record
      socket.on('updateSubCategory', (ms) => {
        if (props.match.params.id === ms) {
          getEach();
        }
      });

      // Socket for delete document record
      socket.on('deleteSubCategory', (ms) => {
        if (props.match.params.id === ms) {
          props.history.push('/cms-sub-categories-add');
        }
      });

      // Socket for getting category record
      socket.on('deleteCategory', (ms) => {
        window.location.reload();
      });

      // Socket for getting category record
      socket.on('category', (ms) => {
        getCat();
        getEach();
      });
    }
    clientSocket();

    getEach();
    getCat();
  }, [props.match.params.id]);

  async function getCat() {
    viewAllRecordCategory()
      .then((response) => {
        setCategories(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function handleSubmit() {
    if (name === '') {
      if (name === '') {
        setNameError('Sub category name is required');
      } else {
        setNameError(null);
      }
    } else {
      setNameError(null);
      editData();
    }
  }

  async function editData() {
    const id = props.match.params.id;
    updateRecord(name, catName, id)
      .then((response) => {
        const socket = io(baseURL);
        const userId = Cookies.get('creadUseDetail');
        socket.emit('subCategory', `${userId}`);
        socket.emit('updateSubCategory', `${props.match.params.id}`);
      })
      .catch((error) => {
        if (error.response.data.userError) {
          Cookies.remove('token');
          Cookies.remove('creadUseDetail');
          props.history.push('/');
          window.location.reload();
        }
      });
  }

  return (
    <div className="content-wrapper">
      <div>
        {/* Content Header (Page header) */}
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1></h1>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6 col-12">
                <div className="card">
                  {/* /.card-header */}
                  <div className="card-body">
                    <div className="form-row">
                      <div className="col-12 form-group">
                        <label>
                          Category list<i className="required-detail">*</i>
                        </label>
                        <select
                          className="form-control"
                          name={catName}
                          onChange={(e) => setCatName(e.target.value)}
                        >
                          <option value={catName._id}>{catName.name}</option>
                          {categories.map((detail) => (
                            <option key={detail._id} value={detail._id}>
                              {detail.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-12 form-group">
                        <label>
                          Edit Sub Category<i className="required-detail">*</i>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name={name}
                          placeholder="Sub Category name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                        {nameError ? (
                          <p className="errorMessage"> {nameError}</p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="card-header">
                    <h3 className="card-title">
                      <Link
                        to="#"
                        onClick={() => handleSubmit()}
                        className="btn btn-info mr-2"
                      >
                        Update Record
                      </Link>
                    </h3>
                  </div>
                  {/* /.card-body */}
                </div>
                {/* /.card */}
                {/* /.card */}
              </div>
              <ViewSubCategories />

              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </section>
        {/* /.content */}
      </div>
    </div>
  );
}

export default SubCategories;
